import React, { useState, useRef, useEffect, useMemo, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidV4 } from 'uuid';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { View } from 'app/modules/rules/domain/View';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import { checkBicAndIban } from 'app/modules/financial/service';
import { useHistory, useLocation } from 'react-router';
import { getContractualDocument, getListImpayeInfo, getOffer, getSubscription } from 'app/modules/contract/service';
import { getBankingInfo, getContractDetails, getUserInfoSelector, getContractState } from 'app/modules/contract/service/store/selectors';
import { IRootState } from 'app/shared/reducers';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import ContractEngineSkeleton from 'app/shared/components/skeleton/contract-engine/contract-engine';
import { getclaimsListBySubscriptionNumber } from 'app/modules/claim/service';
import './style.scss';
import { refreshScroll, upperCaseFirstLetter } from 'app/shared/util/methode-util';
import { emptyRedirectLink } from 'app/modules/claim/service';
import { DEVICES_ARRAY } from 'app/shared/config/constants';
import SwipeableViews from 'react-swipeable-views';
import { updateUserInfo } from 'app/modules/contract/service/index';
import { Card, Tab, Tabs } from '@material-ui/core';
import {
  getContractEngineSelector,
  getContractStatusCms,
  getDesktopContractSelector,
  getModalInformationButton,
} from 'app/modules/cms/service/store/selectors';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import PopUp from 'app/shared/components/common/popup/popup';
import { DeviceType } from 'app/modules/rules/domain/Device.type';
import { Constraint } from 'app/shared/util/constraint';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';

const ContractEngine = props => {
  const [height, setHeight] = useState(0);
  const refHeight = useRef(null);
  const location: any = useLocation();
  const [paymentDate, setPaymentDate] = useState('');
  const [open, setOpen] = useState(false);
  const [menuValue, setMenuValue] = React.useState(0);
  const dispatchor = useDispatch();
  const contractState: any = useSelector<IRootState>(getContractState);
  const rootSubscription: any = contractState?.rootSubscription;
  const contractDetail: any = useSelector<IRootState>(getContractDetails);
  const viewDataitems = useSelector(getDataViewRules(View.CONTRACT_ENGINE));
  const bankInfo: any = useSelector<IRootState>(getBankingInfo);
  const redirect: any = contractState?.redirect;
  const loading: any = contractState?.loading;
  const subsByNumberLoading: any = contractState?.subsByNumberLoading;
  const productOffreLoading: any = contractState?.productOffreLoading;
  const contractuelDocumentsLoading: any = contractState?.contractuelDocumentsLoading;
  const listImpyeLoading: any = contractState?.listImpyeLoading;
  const userInfo: any = useSelector<IRootState>(getUserInfoSelector);
  const listImpaye: any = contractState?.listImpaye;
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const [saveIp, setSaveIp] = useState(false);
  const [query, setQuery] = useState(new URLSearchParams(location.search));
  const [resultatPay, setResultatPay] = useState("");
  const [contractRescind, setContractRescind] = useState(false);
  const contractCms: any = useSelector(getDesktopContractSelector);
  const modalInformation: any = useSelector(getModalInformationButton);
  const {
    match: { params },
  } = props;

  const subsNumber = location.state?.subscription || params?.subNumber;

  const history = useHistory();

  refreshScroll();
  const dispatch = useDispatch();
  const [isReady, setReady] = useState(0);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const rootSubscriptionState = useMemo(() => rootSubscription, [JSON.stringify(viewDataitems), JSON.stringify(rootSubscription)]);
  const productOffre: any = contractState?.productOffre;

  const sousComponentList = useMemo(
    () => viewDataitems?.componentDataList?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB').sousComponentDataList,
    [viewDataitems]
  );
  const [openModal, setOpenModal] = useState(false);
  const redirectLink: any = useSelector<IRootState>(state => state.claim.redirectLink);
  const claimsList: any = useSelector<IRootState>(state => state.claim.claimsList);
  const claimsLoading: any = useSelector<IRootState>(state => state.claim.loading);
  const dataConfList: any = useSelector<IRootState>(state => state.rules.dataConfList);
  const contractEngineCmsData: any = useSelector(getContractEngineSelector);
  const contractCustomerCms: any = useSelector(getContractStatusCms);
  const updatedUserInfo: any = useSelector<IRootState>(state => state.contract.updated);
  const multiClaims = dataConfList.get('GET_CONF')?.multiClaims;
  const claimData = {
    subscriptionNumber: contractDetail?.contact?.subscription?.number,
    claimsList,
    multiClaims,
    loading: claimsLoading,
  };

  const correspandence = key => {
    return contractEngineCmsData?.components?.find(el => el.key === key)?.label;
  };

  const MapAction = (action: string) => {
    let valIndex = 0;
    if (action) {
      switch (action) {
        case 'cotisation':
          valIndex = viewDataitems?.componentDataList[0]?.sousComponentDataList.findIndex(
            e => e.componentDataKey === 'MOBILE_COTISATION_TAB'
          );
          break;

        default:
          break;
      }
    }
    return valIndex;
  };

  const updateUserInfoHandler = (value: any) => {
    dispatchor(updateUserInfo(value, rootSubscription?.number));
  };

  useLayoutEffect(() => {
    if (height !== refHeight.current) setHeight(refHeight?.current?.offsetHeight);
  });

  function getConstrante(constraint, confValue) {
    return Constraint(constraint, { listImpyeState: listImpaye, subscriptionState: rootSubscription }, confValue);
  }

  useEffect(() => {
    if (contractDetail?.number !== '') {
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetOutstandingPayment')) {
        dispatch(getListImpayeInfo(rootSubscriptionState?.number));
      }
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetClaimListBySubscriptionNumber')) {
        dispatchor(getclaimsListBySubscriptionNumber(rootSubscriptionState?.number));
      }
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetOffer')) {
        dispatchor(getOffer((rootSubscription?.offerCodes || [])[0]));
      }

      if (viewDataitems?.dataRecoveryService?.find(service => service === 'getContractualDocument')) {
        dispatchor(getContractualDocument((rootSubscription?.offerCodes || [])[0]));
      }
    }
  }, [viewDataitems, rootSubscription]);

  function toCotisation() {
    const indice = MapAction('cotisation') || 0;
    setMenuValue(indice);
  }

  useEffect(() => {
    if (redirectLink && redirectLink === 'error') {
      setOpenModal(true);
    } else {
      if (redirectLink != null) {
        window.location.href = redirectLink;
      }
    }

    dispatchor(emptyRedirectLink());
  }, [redirectLink]);

  useEffect(() => {
    const subscriptionNumber = subsNumber || params?.subNumber;
    if (subscriptionNumber) {
      dispatchor(getSubscription(subscriptionNumber));
    }
    dispatch(getDocCMS('mobile_contract_engine_v2'));
    dispatch(getDocCMS('desktop_contract_det_v2'));
  }, []);

  useEffect(() => {
    const rulesContext: RulesContext = {
      key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
      entryDataRules: { view: View.CONTRACT_ENGINE, productCode: contractDetail.productCode, deviceType: DeviceType.MOBILE },
    };
    dispatchor(getDataView(rulesContext));
  }, [contractDetail]);

  useEffect(() => {
    const dateNow = new Date();
    dateNow.setHours(dateNow.getHours() + 1);
    const dateNowFormat = dateNow.toISOString().split('.')[0] + '+01:00';
    setPaymentDate(dateNowFormat);
  }, [rootSubscription]);

  useEffect(() => {
    if (redirect) {
      history.push(`/home`);
    }
  }, [redirect]);

  const getPropsText = () => {
    const firstName = contractDetail?.contact?.subscription?.subscriber?.firstName.toLowerCase();
    const model = (contractDetail?.insuredProduct?.insureGods || [])?.find(el => el.active === true)?.model || '';
    let AvatarTitle = contractEngineCmsData.avatar_text;
    if (AvatarTitle) {
      AvatarTitle = upperCaseFirstLetter(AvatarTitle?.replace('{first_name}', firstName));
      AvatarTitle = model !== '' ? AvatarTitle?.replace('{$model}', model) : AvatarTitle?.replace('{$model}', 'model');
    }
    return AvatarTitle;
  };

  useEffect(() => {
    if (isReady === 0 && !!(subsByNumberLoading || productOffreLoading || contractuelDocumentsLoading || listImpyeLoading)) {
      setReady(1);
    } else if (isReady === 1 && !(subsByNumberLoading || productOffreLoading || contractuelDocumentsLoading || listImpyeLoading)) {
      setReady(2);
    }
  }, [subsByNumberLoading, productOffreLoading, contractuelDocumentsLoading, listImpyeLoading]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setMenuValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    if (index !== menuValue) {
      setMenuValue(index);
    }
  };

  const handleChangeIndexTocotisation = (index: number) => {
    handleChangeIndex(
      viewDataitems?.componentDataList
        ?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB')
        ?.sousComponentDataList.findIndex(e => e.componentDataKey === 'MOBILE_COTISATION_TAB')
    );
  };

  useEffect(() => {
    if (updatedUserInfo) {
      setShowSuccessMessage(true);
    }
  }, [updatedUserInfo]);

  useEffect(() => {
    if (query.get('resultat')) {
      // add control msg
      handleChangeIndex(
        viewDataitems?.componentDataList
          ?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB')
          ?.sousComponentDataList.findIndex(e => e.componentDataKey === 'MOBILE_COTISATION_TAB')
      );
      setResultatPay(query.get('resultat'));
    }
  }, [listImpaye]);

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleCheckBicAndIban = (value: any) => {
    const result: any = dispatchor(checkBicAndIban(value));
    return result;
  };

  const getPropsByCompKey = (compKey: any) => {
    switch (compKey) {
      case 'MOBILE_CONTRACT_RECAP':
        return {
          subscription: contractDetail?.contact?.subscription,
          contractDetail,
          claims: claimData,
          open,
          setOpen,
          ContractDetailCms: contractEngineCmsData,
          listImpayeData: listImpaye,
          toCotisation,
          offer: productOffre,
          setContractRescind,
          getConstrante,
          handleChangeIndexTocotisation,
          contractStatusCms: contractCustomerCms,
        };
      case 'MOBILE_USER_TAB':
        return {
          data: userInfo,
          rootSubscription: rootSubscriptionState,
          updateUserInfoHandler,
          userInfoCms: contractEngineCmsData?.contract_personnels_infos,
          setSaveIp,
          updatedUserInfo,
        };
      case 'MOBILE_BANKING_INFO_TAB':
        return {
          data: bankInfo,
          rootSubscription: rootSubscriptionState,
          handleCheckBicAndIban,
          bankInfoCms: contractEngineCmsData?.contract_info_bancaire,
          setSaveIp,
        };
      case 'MOBILE_COTISATION_TAB':
        return {
          data: { amount: productOffre?.fee?.amount || 0, date: '5', currency: DEVICES_ARRAY.get(productOffre?.fee?.currency) || ' €' },
          listImpaye,
          paymentFormatDate: paymentDate,
          subscription: contractDetail?.contact?.subscription,
          resultatPay,
          cotisationCms: contractEngineCmsData,
          handleChangeIndex,
        };
      default:
        break;
    }
  };
  return (
    <>
      {isReady < 2 ? (
        <ContractEngineSkeleton />
      ) : (
        <>
          <div ref={refHeight}>
            <div className="avatar-header-container">
              <div className="avatar-header">
                <AvatarWithBadge previousLink={'/home'} title={[getPropsText()]} avatar={avatar} />
              </div>
            </div>
          </div>
          {contractRescind === false ? (
            <Tabs
              className="contract-engine-mobile-header"
              value={menuValue}
              onChange={handleChange}
              variant={viewDataitems?.componentDataList[0]?.sousComponentDataList?.length <= 2 ? 'fullWidth' : 'scrollable'}
              scrollButtons="auto"
            >
              {viewDataitems?.componentDataList
                ?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB')
                ?.sousComponentDataList?.map((item, index) => {
                  return (
                    <Tab className="Tab-bg-color" key={uuidV4()} label={correspandence(item.componentDataKey)} {...a11yProps(index)} />
                  );
                })}
            </Tabs>
          ) : (
            ''
          )}
          {contractRescind === false ? (
            <div className="scroll-y" style={{ height: `calc(100% - ${refHeight.current?.clientHeight + 140}px)`, overflowY: 'scroll' }}>
              {viewDataitems?.componentDataList?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB')?.sousComponentDataList && (
                <SwipeableViews axis={'x'} index={menuValue} onChangeIndex={handleChangeIndex}>
                  {viewDataitems?.componentDataList
                    ?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB')
                    ?.sousComponentDataList?.map((item, index) => {
                      return (
                        <div key={uuidV4()}>
                          {menuValue === index ? (
                            <div
                              key={uuidV4()}
                              className="p-2 d-flex h-100"
                              role="tabpanel"
                              hidden={menuValue !== index}
                              id={`full-width-tabpanel-${index}`}
                              aria-labelledby={`full-width-tab-${index}`}
                            >
                              <Card className="w-100">
                                <ConfComp
                                  code={item.componentDataKey}
                                  listCode={sousComponentList}
                                  props={getPropsByCompKey(item.componentDataKey)}
                                />
                              </Card>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      );
                    })}
                </SwipeableViews>
              )}
              <div className="pagination d-flex justify-content-center">
                {(
                  viewDataitems?.componentDataList?.find(x => x.componentDataKey === 'MOBILE_CONTRACT_ENGINE_TAB')?.sousComponentDataList ||
                  []
                ).map((item, index) => (
                  <div key={uuidV4()} onChange={() => handleChange} className={`border-pag ${index === menuValue ? 'active' : ''}`}>
                    <span className="item-pag" />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="col-12">
              <ConfComp
                code="MOBILE_CHOICE_RESCIND"
                listCode={viewDataitems?.componentDataList}
                props={{
                  contractCms,
                  confData: viewDataitems?.componentDataList,
                }}
              />
            </div>
          )}
        </>
      )}
      <PopUp open={open} setOpen={setOpen} data={claimData} />
      <ModalWithAction
        showModal={openModal}
        setShowModel={setOpenModal}
        textBody={contractEngineCmsData?.contract_recap?.modal_claim_eligibility}
        action={() => {
          setOpenModal(false);
        }}
        icon={modalInformation?.erreur_Icon?.url}
        btnActionLabel={modalInformation?.CLOSE_button}
      />
      {showSuccessMessage ? (
        <ModalWithAction
          icon={modalInformation?.Success_Icon?.url}
          showModal={true}
          setShowModel={setShowSuccessMessage}
          textBody={contractEngineCmsData?.contract_personnels_infos?.modal_succses_msg}
          btnActionLabel={modalInformation?.UNDERSTAND_button}
          action={() => {
            setShowSuccessMessage(false);
          }}
        />
      ) : null}
    </>
  );
};

export default ContractEngine;
